import { render, staticRenderFns } from "./ManageMyTemplate.vue?vue&type=template&id=c531e9c0&scoped=true"
import script from "./ManageMyTemplate.vue?vue&type=script&lang=js"
export * from "./ManageMyTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c531e9c0",
  null
  
)

export default component.exports